module.exports = __webpack_public_path__ + "static/img/MenuSearch.dfd1cb30.svg";